import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledSubCardActivity,
  Col,
  ActivityNumber,
  ActivityCode,
  ActivityTitle,
} from './style';
import { Badge, Icon, Inline, Text } from '../../../atoms';
import SubCardActivityQuiz from '../SubCardActivityQuiz';
import theme from '../../../theme';
import { timestampToDate } from '../../../../utils/common';

const SubCardActivity = ({ activity }) => {
  const subType =
    activity?.type === 'quiz'
      ? 'quiz'
      : activity?.quiz_score
      ? 'scorm-with-quiz'
      : activity?.completed
      ? 'scorm-no-quiz'
      : 'scorm-no-info';

  return (
    <StyledSubCardActivity>
      <Col>
        <Inline columnGap="24px">
          <ActivityNumber />
          <Badge type="news" uppercase>
            {activity?.type}
          </Badge>
        </Inline>
        <Inline columnGap="19px">
          <ActivityCode>{activity?.code || '-'}</ActivityCode>
          <ActivityTitle>{activity?.title}</ActivityTitle>
        </Inline>
      </Col>
      <Col>
        <Text type="statistics-heading">Completamento</Text>
        <Badge
          color={theme().colors.badgeActive}
          backgroundColor={theme().colors.badgeLightBlueBg}
          fontWeight="600"
        >
          <Inline columnGap="8px">
            {activity?.completed ? 'Sì' : 'No'}
            <Icon
              type={activity?.completed ? 'check-circle' : 'x-circle'}
              size={18}
              stroke={theme().colors.badgeActive}
              clickable={false}
            />
          </Inline>
        </Badge>
      </Col>
      <Col>
        <Inline columnGap="32px" justifyContent="space-between">
          <Inline columnGap="8px">
            <Icon
              type="calendar"
              size={18}
              stroke={theme().colors.primaryDarkGray700}
              clickable={false}
            />
            <Text type="statistics-heading">Data/ora inizio</Text>
          </Inline>
          <Text type="b4" className="date">
            {timestampToDate(activity?.started_time, 'DD/MM/YYYY - HH:mm') ||
              '-'}
          </Text>
        </Inline>
        <svg
          width="18"
          height="23"
          viewBox="0 0 2 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 0.5V22.5"
            stroke={theme().colors.primaryDarkGray700}
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeDasharray="3 3"
          />
        </svg>
        <Inline columnGap="32px" justifyContent="space-between">
          <Inline columnGap="8px">
            <Icon
              type="calendar-check-01"
              size={18}
              stroke={theme().colors.primaryDarkGray700}
              clickable={false}
            />
            <Text type="statistics-heading">Data/ora fine</Text>
          </Inline>
          <Text type="b4" className="date">
            {timestampToDate(activity?.completed_time, 'DD/MM/YYYY - HH:mm') ||
              '-'}
          </Text>
        </Inline>
      </Col>
      <SubCardActivityQuiz subType={subType} activity={activity} />
    </StyledSubCardActivity>
  );
};

SubCardActivity.propTypes = {
  activity: PropTypes.object,
};

export default SubCardActivity;
